require("./bootstrap");
require("vanilla-cookieconsent");
require("./cookieconsent-init");
import "@mdi/font/css/materialdesignicons.css";
import "vanilla-cookieconsent/dist/cookieconsent.css";

window.Vue = require("vue");

import Vue from "vue";
import Vuelidate from "vuelidate";
import Vuex from "vuex";
import VueRouter from "vue-router";
import VueI18n from "vue-i18n";
import VideoBackground from "vue-responsive-video-background-player";
import VueLazyload from "vue-lazyload";

window.select2 = require("vanilla-cookieconsent");

Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(Vuelidate);

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: "/images/error.webp",
    loading: "/images/Spinner-1s-200px.svg",
    attempt: 1
});

const store = new Vuex.Store({
    state: {
        pageParams: {
            page_is_on_references: false,
            page_button_text: "",
            page_title: "",
            page_subtitle: "",
            page_breadcrumbs: []
        },
        appParams: {}
    },
    mutations: {
        setPageParams(state, payload) {
            state.pageParams = payload;
        },

        setAppParams(state, payload) {
            state.appParams = payload;
        }
    },
    actions: {
        async setAppParams(state) {
            await axios
                .get("/getAppParams")
                .then(response => {
                    state.commit("setAppParams", response.data);
                })
                .catch(error => {
                    console.log(error.response.data);
                });
        },

        setPageParams(state, payload) {
            state.commit("setPageParams", payload);
        }
    },
    modules: {},
    getters: {
        getAppParams: state => state.appParams,
        getPageParams: state => state.pageParams
    }
});

Vue.component(
    "app-container",
    require("./frontend/views/AppContainer.vue").default
);
Vue.component(
    "insta-posts",
    require("./frontend/components/InstagramPosts.vue").default
);
Vue.component(
    "hero-cards",
    require("./frontend/components/HeroCards.vue").default
);

Vue.component(
    "hero-cards-color-set",
    require("./frontend/components/HeroCardsColorSet.vue").default
);

Vue.component("video-background", VideoBackground);
Vue.component(
    "carousel",
    require("./frontend/components/Carousel.vue").default
);

import Home from "./frontend/views/Home.vue";
import MainCategory from "./frontend/views/MainCategory.vue";
import Cleaning from "./frontend/views/Cleaning.vue";
import Playhop from "./frontend/views/Playhop.vue";
import Graphics from "./frontend/views/Graphics.vue";
import GraphicsByCategory from "./frontend/views/GraphicsByCategory.vue";
import GraphicsByCategorySubcategory from "./frontend/views/GraphicsByCategory.vue";
import GraphicDetail from "./frontend/views/GraphicDetail.vue";
import Realizations from "./frontend/views/Realizations.vue";
import RealizationDetail from "./frontend/views/RealizationDetail.vue";
import RealizationsByCategory from "./frontend/views/RealizationsByCategory.vue";
import Playgrounds from "./frontend/views/Playgrounds.vue";
import PlaygroundDetail from "./frontend/views/PlaygroundDetail.vue";
import AboutUs from "./frontend/views/AboutUs.vue";
import Contact from "./frontend/views/Contact.vue";
import Download from "./frontend/views/Download.vue";
import EPDM from "./frontend/views/EPDM.vue";
import PrivacyPolicy from "./frontend/views/PrivacyPolicy.vue";
import CookiesPolicy from "./frontend/views/CookiesPolicy.vue";
import Inspirations from "./frontend/views/Inspirations.vue";
import Careers from "./frontend/views/Careers.vue";
import CareerDetail from "./frontend/views/CareerDetail.vue";

const routes = [
    {
        path: "/",
        name: "home",
        component: Home
    },
    {
        path: "/dopadove-plochy",
        name: "mainCategory-1",
        component: MainCategory
    },
    {
        path: "/herni-plochy",
        name: "mainCategory-2",
        component: MainCategory
    },
    {
        path: "/3d-hriste",
        name: "mainCategory-3",
        component: MainCategory
    },
    {
        path: "/mlhoviste",
        name: "mainCategory-4",
        component: MainCategory
    },
    {
        path: "/sportoviste",
        name: "mainCategory-5",
        component: MainCategory
    },
    {
        path: "/trampoliny",
        name: "mainCategory-6",
        component: MainCategory
    },
    {
        path: "/cisteni",
        name: "mainCategory-99",
        component: Cleaning
    },
    {
        path: "/playhop",
        name: "mainCategory-100",
        component: Playhop
    },
    {
        path: "/grafika",
        name: "graphics",
        component: Graphics
    },
    {
        path: "/grafika/:categoryAlias",
        name: "graphicsByCategory",
        component: GraphicsByCategory
    },
    {
        path: "/grafika/:categoryAlias/:subcategoryAlias",
        name: "graphicsByCategorySubcategory",
        component: GraphicsByCategorySubcategory
    },
    {
        path:
            "/grafika/:categoryAlias/:subcategoryAlias/:subcategory2Alias/:graphicAlias",
        name: "graphicDetail",
        component: GraphicDetail
    },
    {
        path: "/realizace",
        name: "realizations",
        component: Realizations
    },
    {
        path: "/realizace/:categoryAlias",
        name: "realizationsByCategory",
        component: RealizationsByCategory
    },
    {
        path: "/realizace/:categoryAlias/:realizationAlias",
        name: "realizationDetail",
        component: RealizationDetail
    },
    {
        path: "/o-nas",
        name: "aboutus",
        component: AboutUs
    },
    {
        path: "/kontakt",
        name: "contact",
        component: Contact
    },
    {
        path: "/ke-stazeni",
        name: "download",
        component: Download
    },
    {
        path: "/kariera",
        name: "careers",
        component: Careers
    },
    {
        path: "/kariera/:careerAlias",
        name: "careerDetail",
        component: CareerDetail
    },
    {
        path: "/epdm",
        name: "epdm",
        component: EPDM
    },
    {
        path: "/typizovana-hriste",
        name: "playgrounds",
        component: Playgrounds
    },
    {
        path: "/typizovana-hriste/:playgroundAlias",
        name: "playgroundDetail",
        component: PlaygroundDetail
    },
    {
        path: "/ochrana-osobnich-udaju",
        name: "privacyPolicy",
        component: PrivacyPolicy
    },
    {
        path: "/zasady-cookies",
        name: "cookiesPolicy",
        component: CookiesPolicy
    },

    {
        path: "/inspirace",
        name: "inspirations",
        component: Inspirations
    }
];

const router = new VueRouter({
    mode: "history",
    routes,
    scrollBehavior(to, from, savedPosition) {
        let yTop = 0;

        if (to.params.savedPosition) return to.params.savedPosition;

        if (to.params.scrollToElementId) {
            let elem = document.getElementById(to.params.scrollToElementId);
            yTop = elem.offsetTop - 100;
        }

        return { x: 0, y: yTop };
    }
});

function loadLocalMessages() {
    const locales = require.context(
        "../../src/locales",
        true,
        /[A-za-z0-9-_,\s]+\.json$/i
    );
    const messages = {};

    locales.keys().forEach(key => {
        const matched = key.match(/([A-za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });

    return messages;
}

const i18n = new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || "cs", //Set locale
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en", //Set fallback locale
    messages: loadLocalMessages() //Set locale messages
});

const opts = {
    lang: {
        t: (key, ...params) => i18n.t(key, params)
    }
};

const app = new Vue({
    el: "#app",
    i18n,
    router,
    store
});
